import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { createAppUrl } from '../createAppUrl';
/**
 * A hook that lets you work with the navigate API in association with app
 * paths, which facilitates complete type-safety.
 */
export const useAppNavigate = () => {
    const navigate = useNavigate();
    const typedNavigate = useCallback((options, navigateOptions) => {
        navigate(createAppUrl(options), navigateOptions);
    }, [navigate]);
    return typedNavigate;
};
